import { ConfirmDialog } from '@trellis/roots/overlays'

export function ImportCommitDialog({
  open,
  onOpenChange,
  validRows,
  errorRows,
  onConfirm,
  isPending,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  validRows: number
  errorRows: number
  onConfirm: () => void
  isPending: boolean
}) {
  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Commit Import"
      description={
        <div className="space-y-2 text-sm">
          <p>This will import {validRows} valid rows.</p>
          {errorRows > 0 && (
            <p className="text-amber-700">
              {errorRows} {errorRows === 1 ? 'row' : 'rows'} with errors will be skipped.
            </p>
          )}
        </div>
      }
      confirmLabel="Commit"
      pendingLabel="Committing…"
      isPending={isPending}
      closeOnConfirm={false}
      onConfirm={onConfirm}
    />
  )
}
